<script>
    import AnimationsMixin from "../../../author/pagesbuilder/mixins/AnimationsMixin";
    import {mapState} from "vuex";

    export default {
        name: "LeadFormElement",
        mixins: [
            AnimationsMixin,
        ],
        data() {
            return {
                elementType: 'lead-form',
                givesContextToChildren: true,
                showOptinCheckbox: null
            }
        },
        computed: {
            ...mapState(['dpSettings']),
            getDefaultDataStructure () {
                return {
                  elementType: this.elementType,
                  elementId: this.elementId,
                  styles: null,
                  tag: "",
                  linkData: {},
                  itemVisibilitySettings: null
                }
            },
        },
        methods: {
            getTags () {
                return this.myData.tag;
            },
            addListeners () {
                // overridden by AuthorLeadWrapperElement and PreviewLeadWrapperElement
            },
            setCheckboxVisibility (isCheckboxVisible) {
                this.showOptinCheckbox = isCheckboxVisible;
            },
            checkboxVisibility () {
                let isCheckboxVisible = true; // true for dpSettins.type === all || dpSettins.type === euonly && isEUCustomer
                if ( typeof this.dpSettings === 'undefined' ||
                    this.dpSettings.type === 'disabled' ||
                    (this.dpSettings.type === 'custom' && !this.dpSettings.marketing ) ||
                    (this.dpSettings.type === 'euonly' && !this.isEUCustomer)
                ){
                    isCheckboxVisible = false;
                }
                this.setCheckboxVisibility(isCheckboxVisible);
            },
            translateElements () {
                // gdpr checkbox label
                const checkboxLabel = this.myNode.querySelector('.js-optin-checkbox-label');
                if (checkboxLabel) {
                    checkboxLabel.innerText = this.$t('common.lead_optin');
                }
            },
            elementCreationCallback () {
                this.addListeners();
                this.translateElements();
                this.checkboxVisibility();
            }
        },
        watch: {
            showOptinCheckbox:{                
                handler(newVal){                    
                    if (newVal) {
                        this.elementNode.classList.add('show-optin-checkbox');
                    } else {
                        this.elementNode.classList.remove('show-optin-checkbox');
                    }
                }
            }
        }
    }
</script>
